import * as React from "react";
import { EGlyphicon } from "../../Shared/Glyphicon/EGlyphicon";
import IconWithText from "../../../services/Shared/IconWithText/IconWithText";
import Render from "../../Shared/Render";
import { GetQuickJournalPaperCenterOffsetInPixels } from "../QuickJournal/View/QuickJournalLayout";
import * as styles from "../BottomBar.css";

export function ExpandedDisplayItems(props: {
    displayLarge: boolean;
    hideGameOptions: boolean;
    keyboardOffsetY: number;
    onCloseQuickJournal: () => void;
}) {
    return (
        <Render id="expandedDisplalyItems" when={props.displayLarge}>
            <span
                style={{
                    display: "block",
                    cursor: "pointer",
                    transform: props.hideGameOptions
                        ? `translateY(${props.keyboardOffsetY}px)`
                        : "translateY(0)",
                    transition: "transform 0.15s ease-out",
                }}
            >
                <IconWithText
                    iconSuffix={EGlyphicon["chevron-down"]}
                    withClass={styles.minimizeBottomBar}
                    customStyle={{
                        opacity: 0.3,
                        transform: `translateX(${GetQuickJournalPaperCenterOffsetInPixels()}px)`,
                    }}
                    whenClicked={props.onCloseQuickJournal}
                    displayAsBlock={true}
                    useButton={true}
                    activateOnPointerUp={true}
                />
            </span>
        </Render>
    );
}
